import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Organization } from '../../models/organization';
import { SelectActiveNode } from '../../../store/actions/orgHierarchy.action';
import {
  selectOrgHierarchyLoadedState,
} from '../../../store/selectors/orgHierarchy.selectors';

interface OrgHierarchyItemProps {
  org: Organization;
  isActive: boolean;
  filterQuery: string;
}

const OrgHierarchyItem = (props: OrgHierarchyItemProps) => {
  const {
    org,
    isActive,
    filterQuery
  } = props;

  const dispatch = useDispatch();
  const loaded = useSelector(selectOrgHierarchyLoadedState);

  const clickHandle = () => {
    dispatch(new SelectActiveNode(org));
  };

  useEffect(() => {
    if (isActive && loaded) {
      // setTimeout(() => {
      //   const element = document.querySelector('#orgHierarchy');
      //   element.scroll({
      //     left: element.scrollWidth,
      //     behavior: 'smooth'
      //   })
      // });
    }
  }, [loaded, isActive, filterQuery]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className={`glympse-orgHierarchy-node-item ${isActive ? 'bg-color-active' : 'bg-white'}`}
         onClick={clickHandle} >
      {
        org?.base_location?.name ? (
          <div>
            <div className="glympse-orgHierarchy-org-name">{org?.name}</div>
            <div className="glympse-orgHierarchy-org-address">{org.base_location.name}</div>
          </div>
        ) : (
          <div className="glympse-orgHierarchy-org-name font-weight-normal">{org?.name}</div>
        )
      }
      { !org?.children || org?.children?.length > 0 ? <span className="glympse-orgHierarchy-greater-than-icon">&rang;</span> : null }
    </div>
  )
};

export default OrgHierarchyItem;
